function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useQuery } from 'react-query';
import { CACHE_KEYS, CACHE_TIMES } from '.';
import { api } from './swaggerApi';
export var useTapQuestionResult = function(param) {
    var tapQuestionIdentifier = param.tapQuestionIdentifier, filters = param.filters, _param_groupAnswers = param.groupAnswers, groupAnswers = _param_groupAnswers === void 0 ? false : _param_groupAnswers, _param_isRunning = param.isRunning, isRunning = _param_isRunning === void 0 ? false : _param_isRunning, campaignResultIdentifier = param.campaignResultIdentifier;
    return useQuery([
        CACHE_KEYS.SINGLE_SURVEY_QUESTION_RESULTS,
        tapQuestionIdentifier,
        groupAnswers,
        _object_spread({}, filters || {})
    ], /*#__PURE__*/ _async_to_generator(function() {
        var _ref, tmp, _ref1, results;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api.insightsPlatform.tapQuestionsResultsDetail(_object_spread({
                            identifier: tapQuestionIdentifier,
                            filters: filters,
                            group_answers: groupAnswers
                        }, !!campaignResultIdentifier && {
                            result_identifier: campaignResultIdentifier
                        }))
                    ];
                case 1:
                    _ref = _state.sent(), tmp = _ref.data, _ref1 = tmp === void 0 ? {} : tmp, results = _ref1.data;
                    return [
                        2,
                        results
                    ];
            }
        });
    }), {
        enabled: !!tapQuestionIdentifier,
        keepPreviousData: false,
        refetchInterval: isRunning ? CACHE_TIMES.TWO_MINUTES : CACHE_TIMES.FIVE_MINUTES
    });
};
export var useTapQuestionCrossTabResult = function(param) {
    var tapQuestionIdentifier = param.tapQuestionIdentifier, crossTabQuestionId = param.crossTabQuestionId, filters = param.filters, _param_groupAnswers = param.groupAnswers, groupAnswers = _param_groupAnswers === void 0 ? false : _param_groupAnswers, _param_isRunning = param.isRunning, isRunning = _param_isRunning === void 0 ? false : _param_isRunning, campaignResultIdentifier = param.campaignResultIdentifier;
    return useQuery([
        CACHE_KEYS.SINGLE_SURVEY_CROSS_TAB_QUESTION_RESULTS,
        tapQuestionIdentifier,
        crossTabQuestionId,
        groupAnswers,
        _object_spread({}, filters || {})
    ], /*#__PURE__*/ _async_to_generator(function() {
        var _ref, tmp, _ref1, results;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api.insightsPlatform.tapQuestionsCrossTabResultsDetail(_object_spread({
                            identifier: tapQuestionIdentifier,
                            cross_tab_question_id: crossTabQuestionId,
                            filters: filters,
                            group_answers: groupAnswers
                        }, !!campaignResultIdentifier && {
                            result_identifier: campaignResultIdentifier
                        }))
                    ];
                case 1:
                    _ref = _state.sent(), tmp = _ref.data, _ref1 = tmp === void 0 ? {} : tmp, results = _ref1.data;
                    return [
                        2,
                        results
                    ];
            }
        });
    }), {
        enabled: !!tapQuestionIdentifier,
        keepPreviousData: false,
        refetchInterval: isRunning ? CACHE_TIMES.TWO_MINUTES : CACHE_TIMES.FIVE_MINUTES
    });
};
export var useQuestionTapAnswersList = function(tapQuestionIdentifier, campaignResultIdentifier) {
    return useQuery([
        CACHE_KEYS.QUESTION_TAP_ANSWERS_LIST,
        tapQuestionIdentifier
    ], /*#__PURE__*/ _async_to_generator(function() {
        var _ref, tmp, _ref1, tapAnswers;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api.insightsPlatform.tapQuestionsTapAnswersListDetail(_object_spread({
                            identifier: tapQuestionIdentifier
                        }, !!campaignResultIdentifier && {
                            result_identifier: campaignResultIdentifier
                        }))
                    ];
                case 1:
                    _ref = _state.sent(), tmp = _ref.data, _ref1 = tmp === void 0 ? {} : tmp, tapAnswers = _ref1.data;
                    return [
                        2,
                        tapAnswers
                    ];
            }
        });
    }), {
        enabled: !!tapQuestionIdentifier,
        keepPreviousData: false,
        staleTime: CACHE_TIMES.SIXTY_MINUTES
    });
};
export var useQualificationAnswerLabels = function(param) {
    var questionId = param.questionId, countryId = param.countryId, languageId = param.languageId, campaignResultIdentifier = param.campaignResultIdentifier;
    return useQuery([
        CACHE_KEYS.QUALIFICATION_ANSWER_LABELS,
        questionId,
        countryId,
        languageId
    ], /*#__PURE__*/ _async_to_generator(function() {
        var _ref, tmp, _ref1, labels;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api.insightsPlatform.qualificationAnswerLabelsList(_object_spread({
                            question_id: questionId,
                            country_id: countryId,
                            language_id: languageId
                        }, !!campaignResultIdentifier && {
                            result_identifier: campaignResultIdentifier
                        }))
                    ];
                case 1:
                    _ref = _state.sent(), tmp = _ref.data, _ref1 = tmp === void 0 ? {} : tmp, labels = _ref1.data;
                    return [
                        2,
                        labels.reduce(function(acc, label) {
                            return _object_spread_props(_object_spread({}, acc), _define_property({}, label.attributes.key, label.attributes.label));
                        }, {})
                    ];
            }
        });
    }), {
        enabled: !!questionId && !!countryId && !!languageId,
        keepPreviousData: true,
        staleTime: CACHE_TIMES.SIXTY_MINUTES
    });
};
